import { useState } from 'react';
import { addToast, Table, Icon } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { getStudentDocumentsTuitionDocumentDownload } from '../../../api/studentDocumentsRequests';
import { useTexts } from '../hooks/useTexts';
import { StudentDocumentTuition } from '../types';

type DocumentsTuitionTableProps = {
  studentId: number;
  data: StudentDocumentTuition[];
};

export function DocumentsTuitionTable({
  studentId,
  data,
}: DocumentsTuitionTableProps) {
  const texts = useTexts();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const getUrl = async (params: {
    type: string;
    documentId: number | string;
  }) => {
    setLoading(true);
    const result = await getStudentDocumentsTuitionDocumentDownload(
      studentId,
      params,
    );
    const { error, data } = result;
    setLoading(false);
    if (error && error.code === 'CONNECTION') {
      return addToast({
        icon: 'error',
        color: 'danger',
        text: 'error de conexión',
      });
    } else if (error) {
      return addToast({
        icon: 'error',
        color: 'danger',
        text: t('common.errors.get'),
      });
    }
    if (data) {
      window.open(data.url, '_blank');
    }
  };

  return (
    <Table
      data={data}
      noResultsText={texts.noResults}
      columns={[
        {
          headerText: texts.documentsTuitionTable.name,
          columnName: 'name',
          width: '25%',
          thClassName: 'text-center',
          tdClassName: 'text-center',
        },
        {
          headerText: texts.documentsTuitionTable.period,
          columnName: 'periodName',
          width: '25%',
          thClassName: 'text-center',
          tdClassName: 'text-center',
        },
        {
          headerText: texts.documentsTuitionTable.studyPlan,
          columnName: 'studyPlanName',
          width: '25%',
          thClassName: 'text-center',
          tdClassName: 'text-center',
        },
        {
          headerText: texts.documentsTuitionTable.fileName,
          columnName: 'filename',
          width: '25%',
          thClassName: 'text-center',
          tdClassName: 'text-center',
        },
        {
          headerText: texts.documentsTuitionTable.action,
          columnName: 'action',
          width: '25%',
          thClassName: 'text-center',
          tdClassName: 'text-center',
          cellFormat({ row }) {
            return (
              <button
                type="button"
                className="btn"
                onClick={() =>
                  getUrl({ type: row.type, documentId: row.documentId })
                }
                disabled={loading}
              >
                <Icon name="download" color="primary" />
              </button>
            );
          },
        },
      ]}
    />
  );
}
